module.exports = __webpack_public_path__ + "media/images/project/A-5c81a7e5b750a945fc611d7c75185e3b.svg";